export enum ImportedOrdersAnalyticsMessages {
  capability = 'orders',
  pageLoadEvent = 'page loaded',
  importedOrdersPageName = 'usfoods:r4:imported orders',
}
